import React from "react";
import { MapPin, ArrowRight } from "lucide-react";
import { AREAS } from "../mock";

export default function Areas() {
  return (
    <section id="areas" className="py-20 bg-[#f0f7fb]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center max-w-2xl mx-auto mb-12">
          <div className="inline-block px-3 py-1 rounded-full bg-sky-100 text-sky-700 text-xs font-bold uppercase tracking-wider mb-3">
            Service Areas
          </div>
          <h2 className="text-3xl md:text-4xl font-extrabold text-[#0a4f8a] mb-3">
            Plumbers Available Across All of Sydney
          </h2>
          <p className="text-slate-600">
            Our local Cheerings team covers every Sydney suburb — from the Eastern Beaches to the Hills District.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3">
          {AREAS.map((area) => (
            <div
              key={area}
              className="group flex items-center justify-between bg-white border border-slate-100 rounded-lg px-4 py-3 hover:border-sky-400 hover:shadow-md transition-all cursor-pointer"
            >
              <div className="flex items-center gap-2">
                <MapPin size={16} className="text-sky-600" />
                <span className="text-sm font-semibold text-slate-700">{area}</span>
              </div>
              <ArrowRight
                size={14}
                className="text-slate-400 group-hover:text-[#0a4f8a] group-hover:translate-x-1 transition-all"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
